import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

type Props = {
  newFlagKey: string;
  setNewFlagKey: (v: string) => void;
  newFlagName: string;
  setNewFlagName: (v: string) => void;
  newFlagDescription: string;
  setNewFlagDescription: (v: string) => void;
  flagSaving: boolean;
  isCreating: boolean;
  onCreate: () => void;
};

export function CreateFlagCard({
  newFlagKey, setNewFlagKey, newFlagName, setNewFlagName,
  newFlagDescription, setNewFlagDescription, flagSaving, isCreating, onCreate,
}: Props) {
  return (
    <Card className="shadow-soft">
      <CardHeader><CardTitle>Create feature flag</CardTitle></CardHeader>
      <CardContent className="space-y-4">
        <div className="grid gap-4 lg:grid-cols-2">
          <div className="space-y-2">
            <Label htmlFor="feature-flag-key">Feature key</Label>
            <Input id="feature-flag-key" placeholder="composer_beta" value={newFlagKey} onChange={(e) => setNewFlagKey(e.target.value)} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="feature-flag-name">Display name</Label>
            <Input id="feature-flag-name" placeholder="Composer beta" value={newFlagName} onChange={(e) => setNewFlagName(e.target.value)} />
          </div>
        </div>
        <div className="space-y-2">
          <Label htmlFor="feature-flag-description">Description</Label>
          <Textarea id="feature-flag-description" placeholder="Internal notes about what this flag controls" rows={3} value={newFlagDescription} onChange={(e) => setNewFlagDescription(e.target.value)} />
        </div>
        <div className="flex justify-end">
          <Button onClick={onCreate} disabled={flagSaving}>
            {isCreating ? "Creating…" : "Create flag"}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
